/**
 * i18next-only localStorage keys.
 *
 * All onboarding state (tap/map/welcome, language_selection_shown,
 * sound_selection_shown, sounds_enabled) lives in the
 * DB (`user_onboarding_kv`) and is read via `useOnboardingState()`. The two
 * keys below remain in localStorage only because i18next needs to pick the UI
 * language synchronously at boot, before the backend query resolves. The DB
 * values (`i18next_lng`, `user_manually_selected_language`) are always the
 * authoritative copy and are refreshed on selection.
 */

export const USER_LANGUAGE_STORAGE_KEY = "i18nextLng";
export const USER_MANUALLY_SELECTED_FLAG_KEY = "user_manually_selected_language";
